import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SET_IS_HCA, setQueryParams } from '../utils';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  client: string = environment.client;
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((r) => {
      setQueryParams(r);
    });
    this.route.data.subscribe((data) => {
      SET_IS_HCA(data.isHca);
    });
  }
}
